import { appContext } from '../../../../AppContext';
import IbssButton from '../../../../Components/Buttons/Button/IbssButton';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import IbssDialog from '../../../../Components/Dialogs/BaseDialog/IbssDialog';

class ConfirmChangesWithMenuPopup extends IbssComponent<IProps, IState>
{

    private get labels() { return appContext().labels; }
    
    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    };

    public render(): JSX.Element
    {
        return (
            <IbssDialog
                maxWidth={'md'}
                open={this.props.open}
                onClose={() => this.props.onClose()}
                dialogContent=
                {
                    <div>{this.labels.funcCateringEditWithNewMenuWarning_D}</div>
                }
                header={this.labels.HubLabelAttention_S}
                footer=
                {
                    <div className='d-flex w-90' style={{ justifyContent: 'space-between' }}>
                        <IbssButton
                            variant="contained"
                            color='secondary'
                            onClick={() => this.props.onCancelClicked()}
                        >
                            {this.labels.funcCateringDiscardChanges_L}
                        </IbssButton>
                        <IbssButton
                            variant="contained"
                            onClick={() => this.props.onContinueClicked()}
                        >
                            {this.labels.funcCateringKeepChanges_L}
                        </IbssButton>
                    </div>
                }
                fullWidth
            />
        )
    }
}

export default ConfirmChangesWithMenuPopup;

export interface IProps
{
    open: boolean;
    onClose: () => void;
    onCancelClicked: () => void;
    onContinueClicked: () => void;
}

export interface IState
{
}